<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "numero",
        label: "ID",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "id",
      },
      {
        key: "numero",
        label: "N° Talonario",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "numero",
      },
      {
        key: "folio_inicial",
        label: "Folio Inicial",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "folio_inicial",
      },
      {
        key: "folio_final",
        label: "Folio Final",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "folio_final",
      },
      {
        key: "fecha_entrega",
        label: "Fecha de Entrega",
        busqueda: "",
        tipo: "date",
        searchable: true,
        path: "fecha_entrega",
      },
      {
        key: "transportes_id",
        label: "Camión",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/transportes",
        parametro: "patente",
        append_parametro: "",
        searchable: true,
        path: "transporte_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "patente",
      },
      {
        key: "conductores_id",
        label: "Conductor",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/conductores",
        parametro: "nombres",
        append_parametro: "",
        searchable: true,
        path: "conductor_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre_completo",
      },

      //{key:'conductores_id',label:'Conductor',busqueda:'',tipo:'select',searchable:true,path:'conductor_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre_completo'},
      //{key:'transportes_id',label:'Transporte',busqueda:'',tipo:'select',searchable:true,path:'transporte.patente',opciones:[],valor_opcion:'id',label_opcion:'patente'},
      {
        key: "observaciones",
        label: "Observaciones",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "observaciones",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 3,
        tipo: "texto",
        key: "numero",
        valor: "",
        label: "N° Talonario",
        disabled: false,
      },
      {
        cols: 3,
        tipo: "numero",
        key: "folio_inicial",
        valor: "",
        label: "Folio Inicial (*)",
        disabled: false,
      },
      {
        cols: 3,
        tipo: "numero",
        key: "folio_final",
        valor: "",
        label: "Folio Final (*)",
        disabled: false,
      },
      {
        cols: 3,
        tipo: "datetime",
        key: "fecha_entrega",
        valor: "",
        label: "Fecha de Entrega (*)",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "select-loadable",
        key: "transportes_id",
        valor: "",
        label: "Seleccione Camión (*)",
        busqueda: "",
        ruta: "/transportes",
        parametro: "patente",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "patente",
      },
      {
        cols: 6,
        tipo: "select-loadable",
        key: "conductores_id",
        valor: "",
        label: "Seleccione Conductor",
        busqueda: "",
        ruta: "/conductores",
        parametro: "nombre_completo",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre_completo",
      },
      //{cols:6,tipo:'select',key:'conductores_id',valor:'',label:'Conductor (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre_completo',disabled:false},
      //{cols:6,tipo:'select',key:'transportes_id',valor:'',label:'Transporte (*)',opciones:[],valor_opcion:'id',label_opcion:'patente',disabled:false},
      {
        cols: 12,
        tipo: "texto",
        key: "observaciones",
        valor: "",
        label: "Observaciones",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Talonario Transbordador",
      ancho: "xl",
      ruta: "/talonarios",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Talonarios de Transbordador",
      titulo_boton: "Crear Talonario",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_conductores();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_conductores() {
      await this.axios
        .get(`${this.api}/conductores?limit=99999999`, this.cabeceras_json)
        .then((res) => {
          this.$set(this.columnas[5], "opciones", res.data.data.data);
          this.$set(this.inputs[5], "opciones", res.data.data.data);
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_transportes();
    },
    async cargar_transportes() {
      await this.axios
        .get(`${this.api}/transportes?limit=99999999`, this.cabeceras_json)
        .then((res) => {
          this.$set(this.columnas[4], "opciones", res.data.data.data);
          this.$set(this.inputs[4], "opciones", res.data.data.data);
        })
        .catch((e) => {
          //alert(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/talonarios${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/talonarios${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/talonarios`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/talonarios/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>